import { css } from '@emotion/react';
import { math } from 'polished';

import { BorderBottomRadius, BorderRadius, BorderTopRadius, BorderBottomLeftRadius, BorderTopRightRadius } from './mixins/_border-radius.mixin';
import { HoverFocus } from './mixins/_hover.mixin';
import { themeColorLevel } from './_functions';
import { breakpointInfix } from './mixins/_breakpoints.mixin';
import { ListGroupItemVariant } from './mixins/_list-group.mixin';

export default $ => css`
  .list-group {
    display: flex;
    flex-direction: column;
    padding-left: 0;
    margin-bottom: 0;
    ${new BorderRadius($.listGroupBorderRadius).include($)};
  }

  .list-group-item-action {
    width: 100%;
    color: ${$.listGroupActionColor};
    text-align: inherit;

    ${new HoverFocus().include(
      $,
      css`
        z-index: 1;
        color: ${$.listGroupActionHoverColor};
        text-decoration: none;
        background-color: ${$.listGroupHoverBg};
      `
    )}

    &:active {
      color: ${$.listGroupActionActiveColor};
      background-color: ${$.listGroupActionActiveBg};
    }
  }

  .list-group-item {
    position: relative;
    display: block;
    padding: ${$.listGroupItemPaddingY} ${$.listGroupItemPaddingX};
    color: ${$.listGroupColor};
    text-decoration: ${$.linkDecoration === 'none' ? 'null' : 'null'};
    background-color: ${$.listGroupBg};
    border: ${$.listGroupBorderWidth} solid ${$.listGroupBorderColor};

    &:first-of-type {
      ${new BorderTopRadius('inherit').include($)};
    }

    &:last-child {
      ${new BorderBottomRadius('inherit').include($)};
    }

    &.disabled,
    &:disabled {
      color: ${$.listGroupDisabledColor};
      pointer-events: none;
      background-color: ${$.listGroupDisabledBg};
    }

    &.active {
      z-index: 2;
      color: ${$.listGroupActiveColor};
      background-color: ${$.listGroupActiveBg};
      border-color: ${$.listGroupActiveBorderColor};
    }

    & + & {
      border-top-width: 0;

      &.active {
        margin-top: ${math(`-${$.listGroupBorderWidth}`)};
        border-top-width: ${$.listGroupBorderWidth};
      }
    }
  }

  ${Object.keys($.gridBreakpoints)
    .map(breakpoint => {
      const infix = breakpointInfix($, breakpoint, $.gridBreakpoints);

      return `
      .list-group-horizontal${infix} {
        flex-direction: row;

        > .list-group-item {
          &:first-of-type {
            ${new BorderBottomLeftRadius($.listGroupBorderRadius).include($)};
            ${new BorderTopRightRadius(0).include($)};
          }

          &:last-child {
            ${new BorderTopRightRadius($.listGroupBorderRadius).include($)};
            ${new BorderBottomLeftRadius(0).include($)};
          }

          &.active {
            margin-top: 0;
          }

          + .list-group-item {
            border-top-width: ${$.listGroupBorderWidth};
            border-left-width: 0;

            &.active {
              margin-left: ${math(`-${$.listGroupBorderWidth}`)};
              border-left-width: ${$.listGroupBorderWidth};
            }
          }
        }
      }
    `;
    })
    .join('')}

  .list-group-flush {
    ${new BorderRadius(0).include($)};

    > .list-group-item {
      border-width: 0 0 ${$.listGroupBorderWidth};

      &:last-child {
        border-bottom-width: 0;
      }
    }
  }

  ${Object.keys($.themeColors).map(color => new ListGroupItemVariant(color, themeColorLevel($, color, -9), themeColorLevel($, color, 6)).include($))}
`;
